import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowDownward.js
// module id = 2078
// module chunks = 2